// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, SetUserFields } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";

export const xngSetUserFields: typeof SetUserFields = props => {
    const { parameter, result } = props;
    if (!result.updatedUser) {
        throw new Error("There was no editingUser set and we are trying to update it.");
    }

    result.updatedUser.email = typeof parameter.email !== "undefined" ? parameter.email : result.updatedUser.email;
    result.updatedUser.firstName =
        typeof parameter.firstName !== "undefined" ? parameter.firstName : result.updatedUser.firstName;
    result.updatedUser.lastName =
        typeof parameter.lastName !== "undefined" ? parameter.lastName : result.updatedUser.lastName;
    result.updatedUser.role = typeof parameter.role !== "undefined" ? parameter.role : result.updatedUser.role;
    result.updatedUser.approver =
        typeof parameter.approver !== "undefined" ? parameter.approver : result.updatedUser.approver;
    result.updatedUser.isApproved =
        typeof parameter.isApproved !== "undefined" ? parameter.isApproved : result.updatedUser.isApproved;

    // xng-change
    if ((parameter as any).orderApprovalThreshold) {
        result.updatedUser.properties = {
            ...result.updatedUser.properties,
            orderApprovalThreshold: (parameter as any).orderApprovalThreshold,
        };
    }
};

replaceInChain(chain, SetUserFields, xngSetUserFields);
